import { Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { Role } from '../../../types/shared/Role';
import { AuthService } from '../services/auth.service';

@Directive()
export abstract class BaseRoleDirective implements OnInit, OnChanges {
    @Input() hidden: boolean = false;
    @Input() role!: Role;

    constructor(
        private authService: AuthService,
        private el: ElementRef
    ) {
    }

    ngOnInit(): void {
        this.updateVisibility();
    }

    ngOnChanges(changes: SimpleChanges): void {
        // Re-evaluate visibility whenever inputs change
        if (changes['hidden'] || changes['role']) {
            this.updateVisibility();
        }
    }

    protected checkRole(): boolean {
        // Return true if the user has the required role
        return this.authService.hasRole(this.role);
    }

    private updateVisibility(): void {
        // Combine role-based visibility and [hidden] binding.
        const hasRole = this.checkRole();
        if (hasRole && !this.hidden) {
            this.el.nativeElement.style.display = '';
        } else {
            this.el.nativeElement.style.display = 'none';
        }
    }
}
